module.exports = __webpack_public_path__ + "media/ets/communition_est-c3b1bd04.png";